import { Container } from '@acies/core';
import { Button, theme } from '@acies/ui';

export default class BottomBar extends Container {
	#calculateButton!: Button;

	public constructor() {
		super();
		this.width = 'fill';
		this.height = 48;
		this.alignment = 'right';
		this.gapHorizontal = 24;
		this.paddingHorizontal = 8;
		this.cornerRadius = 8;
		this.fill = theme.colors.fill.white;
		this.stroke = theme.strokes.soft;
	}

	public get calculateButton(): Button {
		if (!this.#calculateButton) {
			this.#calculateButton = new Button();
			this.#calculateButton.icon = 'refresh-ccw-01';
			this.#calculateButton.text = 'Beregn';
		}
		return this.#calculateButton;
	}

	protected override initialize(): void {
		super.initialize();
		this.addComponents([this.calculateButton]);
	}
}
customElements.define('ac-bottom-bar', BottomBar);
